export const siteInfo = {
  name: '禁漫天堂',
  tagline: '最受欢迎的成人漫画在线阅读平台',
  description: '禁漫天堂是国内领先的成人漫画在线阅读平台，拥有海量高清漫画资源，涵盖日漫、韩漫、欧美漫画等多种类型。平台界面简洁友好，加载速度快，支持多设备访问，为用户提供极致流畅的阅读体验。',
  features: [
    {
      icon: 'ri-book-open-line',
      title: '海量资源',
      description: '收录超过10万部漫画作品，每日更新数百话，满足各类读者的阅读需求。'
    },
    {
      icon: 'ri-smartphone-line',
      title: '多端适配',
      description: '完美支持PC端、平板和手机端访问，随时随地畅享阅读乐趣。'
    },
    {
      icon: 'ri-shield-check-line',
      title: '安全私密',
      description: '采用高级加密技术保护用户隐私，浏览记录严格保密，让您放心阅读。'
    },
    {
      icon: 'ri-speed-up-line',
      title: '极速加载',
      description: '全球CDN加速节点覆盖，图片秒加载，翻页无延迟，阅读体验流畅丝滑。'
    }
  ],
  stats: [
    { value: '10万+', label: '漫画资源' },
    { value: '500万+', label: '注册用户' },
    { value: '每日更新', label: '300+话' },
    { value: '99.9%', label: '服务可用率' }
  ]
};

export const quickLinks = [
  { label: '最新入口', url: '#', icon: 'ri-link', highlight: true },
  { label: '镜像站1', url: '#', icon: 'ri-git-branch-line', highlight: false },
  { label: '镜像站2', url: '#', icon: 'ri-git-branch-line', highlight: false },
  { label: 'APP下载', url: '#', icon: 'ri-download-2-line', highlight: false }
];

export const faqs = [
  {
    question: '禁漫天堂是什么？',
    answer: '禁漫天堂是一个专注于成人漫画的在线阅读平台，提供海量高清漫画资源，涵盖日漫、韩漫、欧美等多种类型，支持PC端和移动端访问，界面简洁流畅，深受广大漫画爱好者喜爱。'
  },
  {
    question: '如何注册禁漫天堂账号？',
    answer: '访问禁漫天堂官网后，点击右上角的"注册"按钮，输入您的邮箱地址或手机号码，设置密码并完成验证码验证，即可成功注册。注册过程仅需1分钟，完全免费。'
  },
  {
    question: '禁漫天堂需要付费吗？',
    answer: '禁漫天堂基础功能完全免费，注册后即可浏览大部分漫画内容。部分独家精品内容可能需要VIP会员才能观看，VIP价格实惠，支持多种支付方式。'
  },
  {
    question: '禁漫天堂打不开怎么办？',
    answer: '如果遇到网站无法访问的情况，建议尝试以下方法：1) 使用本站提供的镜像站入口；2) 切换网络环境（如切换WiFi或使用移动数据）；3) 清除浏览器缓存和Cookie后重试；4) 尝试使用VPN工具。'
  },
  {
    question: '禁漫天堂APP在哪里下载？',
    answer: '您可以在禁漫天堂官网首页找到APP下载入口，支持安卓和iOS系统。安卓用户可直接下载APK安装包，iOS用户请按照页面指引进行安装。建议从官方渠道下载以确保安全。'
  },
  {
    question: '忘记密码怎么办？',
    answer: '在登录页面点击"忘记密码"，输入注册时使用的邮箱或手机号，系统会发送重置密码的链接或验证码。按照提示操作即可重新设置密码。'
  },
  {
    question: '禁漫天堂的漫画多久更新一次？',
    answer: '禁漫天堂每日更新数百话漫画内容，热门连载作品通常会在日本或韩国首发后的24小时内同步上线中文翻译版本，确保用户能够及时阅读到最新内容。'
  }
];

export const testimonials = [
  {
    name: '张先生',
    avatar: '张',
    rating: 5,
    comment: '用了禁漫天堂两年多了，资源真的很全，更新速度也很快。界面做得很清爽，翻页体验特别流畅，强烈推荐给喜欢看漫画的朋友。',
    date: '2026-07-15'
  },
  {
    name: '李女士',
    avatar: '李',
    rating: 5,
    comment: '对比过好几个平台，还是禁漫天堂最好用。分类很细致，找漫画特别方便。手机端的适配也做得很好，晚上躺床上看漫画太享受了。',
    date: '2026-07-10'
  },
  {
    name: '王同学',
    avatar: '王',
    rating: 4,
    comment: '作为漫画重度爱好者，禁漫天堂的资源库真的让我惊喜。日漫和韩漫的收录都很全，画质高清，加载速度也快，已经成为我每天的必备消遣了。',
    date: '2026-06-28'
  },
  {
    name: '赵先生',
    avatar: '赵',
    rating: 5,
    comment: '朋友推荐的这个平台，一试就爱上了。分类导航很清晰，搜索功能也好用，最重要的是更新真的很及时，新番基本都能第一时间看到。',
    date: '2026-06-20'
  }
];

export const contactInfo = {
  email: 'support@jmtthub.com',
  wechat: 'JMTThub_Official',
  qq: '88886666',
  workingHours: '周一至周日 9:00 - 22:00',
  address: '在线服务平台，提供7×24小时自助服务'
};